<template>
  <div id="rule_page" @click="closeMenu()">
    <dd-header/>
    <h2 class="hakotan_title">利用規約</h2>
    <div class="wrapper">
      <div class="main_content">
        <dd-menu ref="menuRef"/>
        <div>
          <dd-user-rule-detial
            :isConstruct="false"
          />
        </div>
      </div>
    </div>
    <dd-footer />
  </div>
</template>
<script>
// Module
import Header from '../components/common/DcHeader'
import DcFooter from '../components/common/DcFooter'
import DDLeftMenu from '../components/top/DcLeftMenu'
import UseRuleDetial from '../components/common/DcUseRuleDetial'
import DcSiteMap from '../components/common/DcSiteMap'
import * as App from '../../utils/App'
import {DC_STORAGE_KEY} from '../../constants/App'

export default {
  name: 'UseRule',
  components: {
    'dd-header': Header,
    'dd-footer': DcFooter,
    'dd-user-rule-detial': UseRuleDetial,
    'dd-menu': DDLeftMenu,
    'dd-sitemap': DcSiteMap
  },
  data () {
    return {
      pageKey: 'dcUseRule',
      pageList: [
        {id: 'top', key: 'dcTop', title: 'トップページ', route: 'DcTop'},
        {id: 'userule', key: 'dcUseRule', title: '利用規約', route: 'UseRule'}
      ],
      userInfo: {}
    }
  },
  computed: {
  },
  methods: {
    closeMenu: function () {
      this.$refs.menuRef.close()
    }
  },
  mounted: function () {
    // カテゴリ
    this.userInfo = App.getLocalStorage(DC_STORAGE_KEY.USER_INFO)
  }
}
</script>
<style src="../css/dc-mainmenu.scss" lang="scss" scoped></style>
<style src="../css/dctop4.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/hakotan/pages/DcUseRule.vue